import React from "react";
import * as S from "./styled";
import isNil from "lodash/isNil";

type tProps = {
  title?: string;
  count?: number;
  className?: string;
  onClick: tVoidFn;
  children: any;
};
const MetaCounter = (props: tProps) => {
  return (
    <S.Wrap dir="ltr" title={props.title} className={props.className}>
      <S.IconWrap
        title={props.title}
        onClick={props.onClick}
        isInteractive={!!props.onClick}
      >
        {props.children}
      </S.IconWrap>
      {!isNil(props.count) && <S.Count>{props.count}</S.Count>}
    </S.Wrap>
  );
};

export default MetaCounter;
